<ng-container *ngIf="project?.private && !self; else defaultView">
  <div (click)="openPrivatePopup()">
    <ng-container *ngTemplateOutlet="contentView">
    </ng-container>
  </div>
</ng-container>
<ng-template #defaultView>
  <a [href]="getProjectDetailLink()" class="no-decor cursor-pointer">
    <ng-container *ngTemplateOutlet="contentView">
    </ng-container>
  </a>
</ng-template>
<ng-template #contentView>
  <h4 class="font-sm font-bold text-center margin-top-4 margin-bottom-2 sparro-grey-900 margin-x-4">
    {{ (project.content?.title ? project.content.title : defaultTitle) | truncate : 50 }}
  </h4>
</ng-template>